import { Component, inject } from '@angular/core';
import { UserStateService } from '../../services/user-state.service';

@Component({
  selector: 'app-post-sign-out',
  templateUrl: './post-sign-out.component.html',
  styleUrls: ['./post-sign-out.component.scss'],
  imports: []
})
export class PostSignOutComponent {

  private readonly userState = inject(UserStateService);

  constructor() {
    this.userState.handleSignOutSuccess();
  }
}
